import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-program-search-end-results',
    templateUrl: './program-search-end-results.component.html',
    styleUrls: ['./program-search-end-results.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramSearchEndResultsComponent implements OnInit {
    constructor() {}

    ngOnInit() {/* empty */}
}
